import React from 'react';
import { BottomNavigation, BottomNavigationAction } from '@material-ui/core';
import Procesos from '@material-ui/icons/ImportContacts';
import CheckIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import ListarDatos from '../../../../general/ListarDatos';
import TareasTerminadas from '../../../../general/TareasTerminadas';
import emma_w from '../../../../../global/imagenes/emma_w.png';

const AVATAR_GRIS = { backgroundColor: '#B8B8B8', color: '#FFFFFF' };

function DetalleRemisionesPendientes({ remisiones, onVerDetalle, onAccion }) {
    if (!Array.isArray(remisiones) || remisiones.length === 0) {
        return (
            <TareasTerminadas
                mensaje='No hay remisiones pendientes'
                marginTop='7%'
                imagen={emma_w}
                widthImg='7%'
            />
        );
    }
    return (
        <ListarDatos
            datos={remisiones}
            id='tbl_remisiones_pendientes'
            titulo='Remisiones pendientes'
            buscar={false}
            fila_principal={(row) => `${row.tipo_servicio?.nombre || ''}`}
            filas={[
                {
                    mostrar: (row) => (
                        <>
                            <strong>Remitente:</strong>{' '}
                            {`${row.remitente?.primer_nombre || ''} ${row.remitente?.primer_apellido || ''} ${row.remitente?.segundo_apellido || ''}`}
                        </>
                    ),
                    nombre: '',
                },
                {
                    mostrar: (row) => (<><strong>Motivo:</strong> {row.motivo || row.descripcion || ''}</>),
                    nombre: '',
                },
                {
                    mostrar: (row) => (<><strong>Nivel de prioridad:</strong> {row.nivel_prioridad?.nombre || ''}</>),
                    nombre: '',
                },
            ]}
            color_avatar={() => AVATAR_GRIS}
            acciones={(row) => (
                <BottomNavigation
                    showLabels
                    style={{ background: 'transparent', boxShadow: 'none', display: 'flex', flexDirection: 'row' }}
                >
                    <BottomNavigationAction label='Detalle' icon={<Procesos />} onClick={() => onVerDetalle?.(row.id)} />
                    <BottomNavigationAction label='Aceptar' icon={<CheckIcon style={{ color: '#2fca6aff' }} />} onClick={() => onAccion?.(row.id, 'aceptar')} />
                    <BottomNavigationAction label='Rechazar' icon={<CancelIcon style={{ color: '#d32f2f' }} />} onClick={() => onAccion?.(row.id, 'rechazar')} />
                </BottomNavigation>
            )}
        />
    );
}

export default React.memo(DetalleRemisionesPendientes);
